<template>
  <div>
    <el-card style="margin-top: 10px" class="box-card">
      <div slot="header" class="clearfix">
        <span>用户净发放</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <!--          <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(2)">导出</el-button>-->
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="100px"
        />
        <el-table-column
          prop="user_grant_coin"
          label="人均净发放金币"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="user_grant_spins"
          label="人均净发放体力"
        />
        <el-table-column
          prop="user_grant_diamond"
          label="人均净发放钻石"
        />
        <el-table-column
          prop="user_grant_beast_coin"
          label="人均净发放野兽币"
        />
        <!--        <el-table-column-->
        <!--          prop="user_consume_coin"-->
        <!--          label="人均分钟消耗金币"-->
        <!--        />-->
        <!--        <el-table-column-->
        <!--          prop="user_consume_spins"-->
        <!--          label="人均分钟消耗体力"-->
        <!--        />-->
      </el-table>
    </el-card>
  </div>

</template>

<script>
import { getUserConsumeStat } from '@/api/statistics/user_remain'
import { scientificFormat } from '@/utils'
export default {
  name: 'UserConsume',
  data() {
    return {
      total: 0,
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 1000,
        startDate: '',
        endDate: '',
        level: -1
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleQuery() {
      this.getTables()
    },
    getTables() {
      this.loading = true
      getUserConsumeStat(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.data
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }
  }
}
</script>

<style scoped>

</style>
